export const replace_special_characters = (originalString, replace_by = '') => {
  return originalString.replace(/[^\w\s]/gi, replace_by);
};
